import { render } from "./TemplateHeader.vue?vue&type=template&id=658df540&ts=true"
import script from "./TemplateHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateHeader.vue?vue&type=script&lang=ts&setup=true"

import "./TemplateHeader.vue?vue&type=style&index=0&id=658df540&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/templates/components/TemplateHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "658df540"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('658df540', __exports__)) {
    api.reload('658df540', __exports__)
  }
  
  module.hot.accept("./TemplateHeader.vue?vue&type=template&id=658df540&ts=true", () => {
    api.rerender('658df540', render)
  })

}


export default __exports__